interface ActiveCampaignIconProps {
  className?: string;
}

/**
 * Generic monochrome "send" mark (Material Symbols, Apache-2.0) — NOT the
 * ActiveCampaign brand logo, which is unavailable through tooling. Rendered
 * in currentColor so it inherits text color like the other settings icons.
 * viewBox 0 0 24 24.
 */
export function ActiveCampaignIcon({ className }: ActiveCampaignIconProps) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-label='ActiveCampaign'
      role='img'
    >
      <path d='M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' />
    </svg>
  );
}
